import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petition-discover',
		path: '/p/:slug/d',
		component: loadable(async () => import(/* webpackChunkName: "pages/petition_discover" */ './index'), {
			exportName: 'PetitionDiscover',
			fallback: Loading,
		}),
		frame: false,
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
